import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { Subject, Observable } from 'rxjs';

const devUrl = environment.backendurl

@Injectable({
  providedIn: 'root'
})
export class TeamCreditsService {

  constructor(private http: HttpClient) { }


  sendteaminviteviaemail(data){
    var url = devUrl + "/team/sendteaminviteviaemail"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('sendteaminviteviaemail', url)));
  }

  fetchteaminvitelink(){
    let url = devUrl + "/team/fetchteaminvitelink"
    return this.http.get(url).pipe(
      map(response => { return response; })
    , catchError(GlobalService.handleError('fetchteaminvitelink', url)));
  }

  fetchallteaminvites(index){
    let url = devUrl + "/team/fetchallteaminvites?startindex="+index
    return this.http.get(url).pipe(
      map(response => { return response; })
    , catchError(GlobalService.handleError('fetchteaminvitelink', url)));
  }

  removemember(data){
    var url = devUrl + "/team/removemember"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('removemember', url)));
  }


  inviteresponse(data){
    var url = devUrl + "/team/inviteresponse"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('inviteresponse', url)));
  }


  reserveadmincredits(data){
    var url = devUrl + "/team/reserveadmincredits"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('reserveadmincredits', url)));
  }

  updatecontactenrichmentcredits(data){
    var url = devUrl + "/team/updatecontactenrichmentcredits"
    return this.http.post(url, data).pipe(map(response => { return response; })
      , catchError(GlobalService.handleError('reserveadmincredits', url)));
  }

  leaveteamlink(){
    let url = devUrl + "/team/leaveteam"
    return this.http.get(url).pipe(
      map(response => { return response; })
    , catchError(GlobalService.handleError('leaveteam', url)));
  }
}
